import { FEATURE_FLAG } from '~/constants/featureFlags';

import type { RouteExportParams } from '~/types/router.type';
export const routeParams: RouteExportParams = {
  featureFlag: FEATURE_FLAG.AGENT_CHAT,
};
